import { PaymentOptionDto } from './PaymentOptionDto';

export class PaymentOptionStorageDto {
    index: number;

    name: string;

    dueDate: string;

    fromDate: string | null;

    toDate: string | null;

    weeks: number;

    price: string;

    constructor(rawPaymentOptions: PaymentOptionDto) {
        this.index = rawPaymentOptions.index;
        this.name = rawPaymentOptions.name;
        this.dueDate = rawPaymentOptions.dueDate;
        this.fromDate = rawPaymentOptions.fromDate;
        this.toDate = rawPaymentOptions.toDate;
        this.weeks = rawPaymentOptions.weeks;
        this.price = rawPaymentOptions.price.toFixed(2);
    }
}
